import { Tooltip, TooltipTrigger } from "@/components/base/tooltip/tooltip";
import type { Severity } from "@/components/safety-config/risk-groups";
import { cx } from "@/utils/cx";

// Same severity colors as RiskRow's SEVERITY_TEXT (components/safety-config/RiskRow.tsx).
const SEVERITY_STYLE: Record<Severity, { bg: string; text: string }> = {
  critical: { bg: "bg-error-50", text: "text-error-700" },
  high: { bg: "bg-error-50", text: "text-error-700" },
  medium: { bg: "bg-warning-50", text: "text-warning-700" },
  low: { bg: "bg-success-50", text: "text-success-700" },
};

type RiskSeverityPillProps = {
  name: string;
  severity: Severity;
  tooltipInfo?: string;
};

export const RiskSeverityPill = ({ name, severity, tooltipInfo }: RiskSeverityPillProps) => {
  const style = SEVERITY_STYLE[severity];
  const badge = (
    <span className={cx("inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5", style.bg)}>
      <span className={cx("text-xs font-medium capitalize", style.text)}>{name}</span>
    </span>
  );
  if (!tooltipInfo) return badge;
  return (
    <Tooltip title={name} description={tooltipInfo}>
      <TooltipTrigger>{badge}</TooltipTrigger>
    </Tooltip>
  );
};
